<template>
  <div class="rolemanagetable">
    <el-table :data="tableData"
              style="width: 100%;padding:10px 10px 0 10px;"
              border>
      <el-table-column prop="createAtMY"
                       label="打包时间"
                        width="140">
      </el-table-column>
      <el-table-column prop="title"
                       label="标题"
                       :show-overflow-tooltip="true">
      </el-table-column>

      <el-table-column prop="size"
                       label="压缩包大小">
        <!-- <template slot-scope="scope">
          <div>暂无数据</div>
        </template> -->
      </el-table-column>

      <el-table-column prop="statusTitle"
                       label="打包状态"
                        width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.status === 'success'">
            <el-tag type="success">{{scope.row.statusTitle}}</el-tag>
          </div>

          <div v-if="scope.row.status === 'error' ">
            <el-tag type="danger">{{scope.row.statusTitle}}</el-tag>
          </div>

          <div v-if="scope.row.status === 'none'">
            <el-tag type="info">{{scope.row.statusTitle}}</el-tag>
          </div>

          <div v-if="scope.row.status === 'warn'">
            <el-tag type="warning">{{scope.row.statusTitle}}</el-tag>
          </div>

        </template>
      </el-table-column>

      <el-table-column label="操作"
                       width="300">
        <template slot-scope="scope">
          <!-- <div v-if="scope.row.status !== '失败' && scope.row.status !== '打包中……'">
            <el-button @click="openClick(scope)" type="text" class="btn" size="small">下载链接</el-button>
            <span style="margin:0 8px;"> | </span>
            <el-button @click="changeClick(scope)" type="text" class="btn" size="small">二维码</el-button>
          </div> -->

          <div style="display:flex;align-items: center;">
            <span v-if="scope.row.status === 'error' ">
              <el-button @click="closeClick(scope)"
                         type="text"
                         class="btn"
                         size="small">重新打包</el-button>

            </span>

            <span v-if="scope.row.status === 'warn'">
              <div>请等待打包结束！</div>
            </span>

            <span v-if="scope.row.status === 'none'">
              <div>无</div>
            </span>
            <span v-if="scope.row.status === 'success'">
              <a :href="picPrefix+scope.row.downloadUrl"
                 style="color: #185ED3;"
                 target="_blank">
                <i class="el-icon-download"></i>
                点击下载</a>

            </span>
            <span style="margin:0 11px;"> | </span>

            <span>
              <el-button @click="seePic(scope)"
                         type="text"
                         style="color:#3086F0;font-weight:bold;font-size:13px;"
                         class="btn"
                         size="small"><i style="margin-right:3px;"
                   class="el-icon-picture-outline"></i>查看图片</el-button>
            </span>
            <span style="margin:0 11px;"> | </span>
            <span>
              <el-button @click="deleteRecord(scope)"
                         type="text"
                         style="color:#3086F0;font-weight:bold;font-size:13px;"
                         class="btn"
                         size="small"><i style="margin-right:3px;"
                   class="el-icon-picture-outline"></i>删除记录</el-button>
            </span>
          </div>
        </template>

      </el-table-column>

    </el-table>
  </div>
</template>

<script>
import { picPrefix } from "@/constants/piccommon"
import { deletePicturePackage } from "@/api/picturePackage"
export default {
  name: 'rolemanagetable',
  props: {
    tableData: Array,
  },
  data () {
    return {
      picPrefix
      // tableData:[
      //   {
      //     date:'2020-4-20 14:08',
      //     title:'茶道合集图库',
      //     num:'523',
      //     size:'0M',
      //     state:'失败'
      //   },
      //   {
      //     date:'2020-4-20 14:08',
      //     title:'茶道合集图库',
      //     num:'523',
      //     size:'0M',
      //     state:'打包中……'
      //   },{
      //     date:'2020-4-20 14:08',
      //     title:'茶道合集图库',
      //     num:'23',
      //     size:'45M',
      //     state:'成功'
      //   },{
      //     date:'2020-4-20 14:08',
      //     title:'茶道合集图库',
      //     num:'45',
      //     size:'564M',
      //     state:'2000次'
      //   },
      // ]
    }
  },
  methods: {
    deleteRecord (scope) {
      // console.log(scope.$index);
      // console.log(scope);
      // console.log(this.tableData);
      // return
      this.$confirm('确认删除本条下载记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deletePicturePackageAsync(scope)
      }).catch(() => {
      });

    },
    async deletePicturePackageAsync (scope) {
      let { status, data, message } = await deletePicturePackage(scope.row.id)
      if (status) {
        this.$message.success('删除成功！')
        this.tableData.splice(scope.$index, 1)
        console.log(this.tableData);
      } else {
        this.$message.error('删除失败！')
      }
    },
    openClick (scope) {

    },
    closeClick (scope) {

    },
    changeClick (scope) {
      this.$emit('changeClick', scope)
    },
    seePic (scope) {
      this.$emit('seePic', scope)
    },
    removeClick (scope) {
      this.$emit('removeClick', scope)
    },
  },
  created () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table {
  width: auto;
}
a:link {
  text-decoration: none;
}
a:active {
  text-decoration: blink;
}
a:hover {
  text-decoration: underline;
}
a:visited {
  text-decoration: none;
}
.btn:hover {
  text-decoration: underline;
}
</style>
